import WeekCalendar from './week-calendar';

export default WeekCalendar;